import { render, staticRenderFns } from "./CorrectnessIndicator.vue?vue&type=template&id=16ebd0f4&scoped=true&"
import script from "./CorrectnessIndicator.vue?vue&type=script&lang=js&"
export * from "./CorrectnessIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CorrectnessIndicator.vue?vue&type=style&index=0&id=16ebd0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebd0f4",
  null
  
)

export default component.exports